import { createContext } from 'react';

import { ZoomRanges } from '../../core/types/interactions.js';
import type { HistogramZoomDomain } from '../types/histogram.js';

export const HistogramZoomRangesContext = createContext<
  ZoomRanges<HistogramZoomDomain>
>({});

HistogramZoomRangesContext['displayName'] = 'HistogramZoomRangesContext';
